module.exports = __webpack_public_path__ + "fonts/FuturaPT-LightObl.802cf510.woff2";